module.exports = __webpack_public_path__ + "static/chinaPDF-862bc6b1b2323fbe5298c5a1e69b3a72.png";